// extracted by mini-css-extract-plugin
export default {"Card":"BookNowButton_Card__Ko8ix","bookNow":"BookNowButton_bookNow__uHbQi"};